import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut, WareHouseDetailsModal } from '../../components';
import { DISPATCH_ID, json, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import $ from 'jquery';
import { ReabsDetails, UserFields, WareHouseModel } from '../../components/NewOrder';
import { setUserFieldValue, setUserFieldValueDefault } from '../../libs/utils/GlobalFunc';
import moment from 'moment';
import ReabsResumeDetailsModal from '../../components/ReabsResumeDetailsModal';
let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Orden", active: true, key: 'DocNum' },
    { title: "UUID", active: true, key: 'requestId' },
    { title: "Creador", active: true, key: 'Creator' },
    { title: "Factura", active: true, key: 'Invoice' },
    { title: "Cesión Uso", active: true, key: 'CeUso' },
    { title: "Gasto Administrativo", active: true, key: 'GA' },
    { title: "Entrada de Mercancía", active: true, key: 'ENTRY' },
];

class ReProcessMVentasView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            data: [],
            newOrderModel: {},
            showDocDetailsModal: false,
            action: 'new',
            configHeaderUserFields: [],
            searchData: {
                dateTo: moment().format('YYYY-MM-DD'),
                dateFrom: moment().format('YYYY-MM-DD')
            }

        }
    }

    componentDidMount = async () => {
        this.listDocs();
    }
    listDocs = async (search) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { searchData } = this.state
        enableSpinner(true);
        const listDocs = await apiClient.listDocsMVentas(searchData);
        enableSpinner(false);

        if (listDocs.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: listDocs?.data ?? [],
            })
        } else {
            showAlert({ type: 'error', message: listDocs.message })
        }
    }

    fillReabsModel = (model, data) => {
        model.lines = data

        return model;
    }
    getUserFields = async (table, header) => {
        const { enableSpinner } = this.props
        enableSpinner(true)
        let userFieldsResponse = await apiClient.getUserFields(table);
        enableSpinner(false)
        let userFieldsHeader = [];
        let userFieldsBody = [];
        if (userFieldsResponse.status === SERVICE_RESPONSE.SUCCESS) {
            userFieldsHeader = userFieldsResponse.data.header || [];
            userFieldsBody = userFieldsResponse.data.body || [];
        }
        let userFields = new UserFields();
        for (let index = 0; index < json.userFieldsWareHouse.length; index++) {
            const field = json.userFieldsWareHouse[index];
            for (let indez = 0; indez < userFieldsHeader.length; indez++) {
                const userfield = userFieldsHeader[indez];
                if (field.fieldId === userfield.header.FieldID) {
                    json.userFieldsWareHouse[index].name = userfield.header.Descr;
                    field.name = userfield.header.Descr;
                    field.fieldType = userfield.options.length != 0 ? 2 : 1;
                    field.options = userfield.options;
                    field.IdValue = index;
                    let newUserFields
                    if (header) {
                        newUserFields = setUserFieldValue(userFields, index, header);
                    } else {
                        newUserFields = setUserFieldValueDefault(userFields, index, userfield.header);
                    }

                    if (field.fieldType === 2) {
                        field.options.push({ FldValue: "", Descr: "" });
                    }
                    userFields = newUserFields;
                }
            }
        }
        this.setState({
            configHeaderUserFields: json.userFieldsWareHouse
        })

        return userFields
    }
    detailsReabsResume = async (request) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props

        enableSpinner(true);
        const details = await apiClient.reabsResumeDetails(request);
        enableSpinner(false);

        if (details.status === SERVICE_RESPONSE.SUCCESS) {
            let newOrderModel = new ReabsDetails();
            newOrderModel = this.fillReabsModel(newOrderModel, details?.data ?? {});

            this.setState({
                newOrderModel,
                showDocDetailsModal: true,
                action: 'update',
            }, () => {
                $('#reabsResumeDetailsModal').modal('show');
            })
        } else {
            showAlert({ type: 'error', message: details.message })
        }
    }
    refreshModel = newOrderModel => {
        this.setState({
            newOrderModel
        })
    }

    refreshSearch = searchData => {
        this.setState({
            searchData: { ...searchData }
        })
    }
    resetData = () => {
        this.setState({
            data: [],
            newOrderModel: {},
            showDocDetailsModal: false,
            action: 'new',
        }, () => {
            this.listDocs();
        })
    }

    openConfigUserFieldsHeaders = () => {

        let userFields = json.userFieldsWareHouse
        this.setState({
            configHeaderUserFields: userFields,
        }, () => {
            $('#configUserFieldsModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        })

    }
    render() {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { _user, data, newOrderModel, showDocDetailsModal, action, configHeaderUserFields, searchData } = this.state
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'RE-PROCESAR DOCUMENTOS MVENTAS'} url1={'#'} />

                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a href=" " id="reprocessDocumentsMVentas" className="text-muted">
                            &nbsp;RE-PROCESAR DOCUMENTOS MVENTAS
                        </a>
                    </h2>
                    <DataTables
                        headers={headersDataTable}
                        view={"reprocessDocumentsMVentas"}
                        data={data}
                        search={this.listDocs}
                        openDetails={this.detailsReabsResume}
                        details={newOrderModel}
                        searchData={searchData}
                        refreshSearch={this.refreshSearch}
                    />
                </div>
                {showDocDetailsModal &&
                    <ReabsResumeDetailsModal
                        action={action}
                        newOrderModel={newOrderModel}
                        refreshModel={this.refreshModel}
                        enableSpinner={enableSpinner}
                        showAlert={showAlert}
                        resetData={this.resetData}
                        view={"reabsResume"}
                        configHeaderUserFields={configHeaderUserFields}
                        openConfigUserFieldsHeaders={this.openConfigUserFieldsHeaders}
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReProcessMVentasView);
